import { Pipe, PipeTransform } from '@angular/core';
import { Product } from 'idt-ecommerce-api/catalog/products/products.models';

import { LinkedProduct } from 'extensions/core/piece-showcase/front/models/piece-showcase.models';


@Pipe({ name: 'getLinkedProductById' })
export class GetLinkedProductByIdPipe implements PipeTransform {

  public transform(linkedProducts: Product[], productId: string): Product | undefined {
    return linkedProducts.find((linkedProduct) => linkedProduct.id === productId);
  }

}

@Pipe({ name: 'getAvailableLinkedProducts' })
export class GetAvailableLinkedProductsPipe implements PipeTransform {

  public transform(linkedProducts: Product[], linkedProductSettings: LinkedProduct[]): LinkedProduct[] {
    const productIds = linkedProducts.map((linkedProduct) => linkedProduct.id).flat();
    return linkedProductSettings.filter((lps) => productIds.includes(lps.product));
  }

}
